import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useTranslation } from 'react-i18next';
import { Chip, SxProps, Theme } from '@mui/material';

interface VideoChipProps {
  readonly dark?: boolean;
}

export default function VideoChip({ dark = false }: VideoChipProps) {
  const { t } = useTranslation();

  let styles: SxProps<Theme> = {
    color: 'text.secondary',
  };

  if (dark) {
    styles = {
      backgroundColor: '#000000B2',
      color: 'white',
    };
  }

  return (
    <Chip
      label={t('chips.video')}
      color='default'
      size='small'
      sx={styles}
      icon={
        <PlayCircleOutlineIcon
          style={{ color: dark ? 'white' : 'text.secondary' }}
        />
      }
    />
  );
}
